import axios from 'axios';
import { makeUseAxios } from 'axios-hooks';
import { useShippingDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';

export const useCheckAvailability = (
  itemId,
  itemIds,
  isMajorApplianceItemOrItems
) => {

  if (!isMajorApplianceItemOrItems) return useShippingDeprecated({ lazy: true });

  const idOrIds = itemId || (Array.isArray(itemIds) && !!itemIds.length ? itemIds.join() : '');
  const useAxios = makeUseAxios({
    axios: axios.create({ baseURL: idOrIds ? '/mcc-cart/v3/appliance/deliveryAvailability/' : '' })
  });

  return useAxios('', { manual: true });
};